import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";

export default class BooleanValueFormatter extends AbsEditViewValueFormatter {
  private static _instance: BooleanValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new BooleanValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): boolean {
    if (!value)
      return false;
    return value;
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: boolean): boolean {
    return value;
  }
}
